'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.yearsUntil;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/yearsUntil.js
// module id = 302
// module chunks = 1